import React from 'react';
import { string, arrayOf, object } from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { NotableClientsCompactBar } from '@fiverr-private/seller_presence';
import { Popover } from '@fiverr-private/fit';

import './style.scss';

const NotableClients = ({ className, clients=[] }) => {
    if (isEmpty(clients)) {
        return null;
    }

    const notableClientsBarProps = {
        notableClients: clients,
        hiddenClientsMode: NotableClientsCompactBar.HIDDEN_CLIENTS_MODE.PLUS,
        origin: 'expert_card_gig_page',
        labelClassName: 'hidden',
        popoverPosition: Popover.POSITIONS.BOTTOM
    };

    return (
        <div className={classnames(className, 'flex notable-clients')}>
            <p className="m-r-8 text-semi-bold co-text-darker title"><I18n k="gig_page_perseus.expert_card.among_clients"/></p>
            <NotableClientsCompactBar {...notableClientsBarProps}/>
        </div>
    );
};

NotableClients.propTypes = {
    notableClients: arrayOf(object),
    className: string
};

export default NotableClients;
